import { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Stack,
  TextField,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  Card,
  IconButton,
} from "@mui/material";
import {
  DateFormater,
  formatAmount,
  GetReadOnlyInputProps,
  Loader,
} from "../../../../HelperFunctions/HelperFunctions";
import ChargeBacksTabTable from "./ChargeBacksTabTable";
import { DatePicker } from "rsuite";
import PendingTable from "./PendingTable";
import {
  useLocation,
  useOutletContext,
  useRouteLoaderData,
} from "react-router-dom";
import {
  getChargebacks,
  getChargeBacksTabsValues,
} from "../../../../API/backendAPI";
import { enqueueSnackbar } from "notistack";
import ArrowDownIcon from "@rsuite/icons/ArrowDown";
import CloseIcon from "@mui/icons-material/Close";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import success from "../../../../Images/success.png";
import cross2 from "../../../../Images/cross2.png";
import { getPCS, userPref } from "../../../../API/nimbleAPI";

// const Chargebacks = ({ selectedCorp, setSelectedCorp, toUpdatemainTabsValue, merchantProvider }) => {
const Chargebacks = () => {
  const {
    selectedCorp: outletCorp,
    merchantProvider,
    setRestartSSE
  } = useOutletContext();
  const location = useLocation();
  const { pcid, bankAccountId, corporationId } = location.state || {};

  const { corpName, statusType } = location.state || {};
  const [last30Days, setlast30Days] = useState(0);
  const [pcNames, setPcNames] = useState([]);
  const [selectedPC, setSelectedPC] = useState(null);

  const {
    corporations,
    clientId,
    userId,
    userPreference,
    merchantName,
    pcID,
    from_todate,
    screentype
  } = useRouteLoaderData("reconciliation");


  const tabInfo = [
    { tabName: "Pending", key: "pending" },
    { tabName: "Reversed", key: "reversed" },
    { tabName: "Irreversible", key: "irreversible" },
  ];

  const days = [
    { key: 0, value: 0 },
    { key: 1, value: 1 },
    { key: 2, value: 2 },
    { key: 4, value: 4 },
    { key: 5, value: 5 },
    { key: 6, value: 6 },
    { key: 7, value: 7 },
  ];

  const statusList = [
    {
      statusName: "Responded",
      statusValue: "1",
    },
    {
      statusName: "Not Responded",
      statusValue: "0",
    },
  ];

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const initialCorp =
    corporations.find((c) => c.ID === corporationId) ||
    corporations.find((c) => c.ID === outletCorp?.ID) ||
    outletCorp;

  // const initialCorp = corpName
  // ? corporations.find((c) => c.Name === corpName) || outletCorp
  // : outletCorp;

  const [selectedCorpState, setSelectedCorpState] = useState(initialCorp);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(screentype ?? "Pending");
  // const [selectedCorp, setSelectedCorp] = useState(corporations[0]);
  const [selectedTabData, setSelectedTabData] = useState([]);

  const parts = from_todate?.split("&")?.[1]?.split("-");
  const dateFromUrl = parts
    ? new Date(parts[2], parts[0] - 1, parts[1])
    : null;
  const [date, setDate] = useState(dateFromUrl ?? new Date());
  const [tempChargeBackDate, setTempChageBackDate] = useState(date)

  const [tabAmounts, setTabAmounts] = useState({
    pending: 0,
    reversed: 0,
    irreversible: 0,
  });

  const [daysLeft, setDaysLeft] = useState(days[0]);
  const [status, setStatus] = useState(statusList[1]);
  const [showCard, setShowCard] = useState(true);


  useEffect(() => {
    setSelectedPC(null); // reset selected PC
  }, [selectedCorpState?.ID]);

  useEffect(() => {
    // need to change entire PC concept 
    const fetchPCs = async () => {
      try {
        const response = await getPCS(selectedCorpState?.ID);
        const names = response?.map((item) => item.Name) || [];

        setPcNames(names);

        // Remove "-Select-" from list
        const realOptions = names.filter((name) => name !== "-Select-");

        if (realOptions.length === 0) {
          // Only "-Select-" exists
          setSelectedPC("-Select-");
        } else if (realOptions.length === 1) {
          // Only one real option exists
          const pc = response.find(item => item.ID === pcID);
          const pcName = pc?.pc_name;
          // setSelectedPC(realOptions[0]);
          setSelectedPC(pcName ?? realOptions[0]);
        }
      } catch (error) {
        console.error("Error fetching PCs:", error);
      }
    };

    if (selectedCorpState?.ID) {
      fetchPCs();
    }
  }, [selectedCorpState]);

  useEffect(() => {
    getTabGridData();

    // }, [selectedCorp?.ID, date, selectedTab, status?.statusValue]);
  }, [
    selectedCorpState?.ID,
    date,
    selectedTab,
    status?.statusValue,
    selectedPC,
  ]);

  const getTabGridData = async () => {
    // if (!selectedCorp?.ID || !date) return;
    if (!selectedCorpState?.ID || !date) return;
    try {
      setLoading(true);
      setSelectedTabData([]);
      // let corpId = selectedCorp?.ID === "select" ? "" : selectedCorp?.ID;
      let corpId =
        selectedCorpState?.ID === "select" ? "" : selectedCorpState?.ID;
      let merchant_provider = merchantProvider ? merchantProvider : "";
      const tabStatus =
        selectedTab === "Pending"
          ? status.statusValue === "0"
            ? 0
            : 1
          : selectedTab === "Reversed"
            ? 2
            : 3;

      // if (!corpId) {
      //   enqueueSnackbar("Please select a corporation", { variant: "warning" });
      //   return;
      // }
      const payload = {
        client_id: clientId,
        user_id: userId,
        corp_id: corpId,
        as_of_date: DateFormater(date),
        status: tabStatus,
        merchant_provider,
        pc_id: pcid,
        bankAccount_Id: bankAccountId,
      };
      const getData = await getChargebacks(payload);

      const AvgDaysValue = Number(getData?.[0]?.last_30_days_sum || 0);
      // const AvgDaysValue =  2
      setlast30Days(AvgDaysValue);
      await ChargeBackTabValues();

      setSelectedTabData(getData);
    } catch (error) {
      enqueueSnackbar("Error while getting peding data", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const ChargeBackTabValues = async () => {
    try {
      const tabValuesPayload = {
        client_id: clientId,
        // corp_id: selectedCorp?.ID === "select" ? "" : selectedCorp?.ID,
        corp_id:
          selectedCorpState?.ID === "select" ? "" : selectedCorpState?.ID,
        as_of_date: DateFormater(date),
      };

      const getTabValues = await getChargeBacksTabsValues(tabValuesPayload);
      setTabAmounts({
        pending: getTabValues.pending || 0,
        reversed: getTabValues.reversed || 0,
        irreversible: getTabValues.irreversible || 0,
      });
    } catch (error) { }
  };

  const CustomSelect = ({
    label,
    options,
    selectedValue,
    onChange,
    getValue,
    getLabel,
    sx = {},
  }) => {
    return (
      <FormControl variant="filled" size="small" sx={{ minWidth: 200, ...sx }}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={selectedValue || ""}
          onChange={(e) => {
            const selected = options.find(
              (opt) => getValue(opt) === e.target.value,
            );
            onChange(selected || null);
          }}
        >
          {options.map((opt) => (
            <MenuItem key={getValue(opt)} value={getValue(opt)}>
              {getLabel(opt)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const SuccessCard = ({ message, onClose }) => {
    return (
      <Card
        sx={{
          px: 2,
          py: 0.5,
          position: "relative", // <-- IMPORTANT
          display: "flex",
          alignItems: "center",
          borderBottom: "2px solid #4caf50",
          borderRadius: 1,
          minWidth: 250,
          fontSize: "9px",
        }}
      >
        <IconButton
          size="small"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 2,
            top: 1,
            padding: "3px",
          }}
        >
          <img
            src={cross2}
            alt="close"
            style={{
              width: 6,
              height: 6,
              display: "block",
            }}
          />
        </IconButton>

        <Box
          sx={{
            mr: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={success} alt="success" style={{ width: 25, height: 25 }} />
        </Box>

        <CardContent
          sx={{
            p: 0,
            "&:last-child": {
              paddingBottom: 0,
            },
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ color: "#1f1f1f", fontSize: "10px" }}
          >
            Great Work!
          </Typography>

          <Typography
            // noWrap
            variant="body2"
            sx={{ mt: 0.5, color: "#333", fontSize: "10px" }}
          >
            ${Number(last30Days || 0).toLocaleString()} recovered via {message}
          </Typography>
        </CardContent>
      </Card>
    );
  };

  return (
    <>
      <Stack height={"100%"} gap={2}>
        <Stack
          justifyContent={"space-between"}
          direction={"row"}
          alignItems={"flex-end"}
          gap={0.5}
        >
          <Stack
            direction={"row"}
            spacing={2}
            // flexGrow={1}
            alignItems={"flex-end"}
          >
            <Autocomplete
              disableClearable
              size="small"
              options={corporations}
              // getOptionDisabled={(option) => option.ID === "select"}
              // value={selectedCorp}
              value={selectedCorpState}
              onChange={(e, val) => setSelectedCorpState(val)}
              getOptionLabel={(option) =>
                userPref ? option.LegalName : option.Name
              }
              isOptionEqualToValue={(option, value) => option.ID === value?.ID}
              sx={{ minWidth: 250, flexGrow: 1 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // {...(
                  //     ["Select corporation"].includes(params.inputProps?.value) &&
                  //     GetReadOnlyInputProps(params)
                  // )}
                  label="Corporation"
                  variant="filled"
                />
              )}
            />
            {!(pcNames.length === 1 && pcNames[0] === "-Select-") && (
              <Autocomplete
                disableClearable
                options={pcNames}
                value={selectedPC}
                sx={{ minWidth: 210, flexGrow: 1 }}
                onChange={(e, val) => setSelectedPC(val)}
                getOptionLabel={(option) => option || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Profit Center"
                    variant="filled"
                    size="small"
                  />
                )}
              />
            )}

            <Stack>
              <Typography
                style={{ fontSize: "10px", fontWeight: 400, color: "#7b7b7b" }}
              >
                As of date
              </Typography>
              <div style={{ width: "100%" }}>
                <DatePicker
                  disabledDate={(date) => date > new Date()}
                  value={tempChargeBackDate}
                  // onChange={(value) => setDate(value)}
                  onChange={(value) => {
                    if (value === null) {

                      setDate((prev) => new Date(prev.getTime() + 1));
                      setTempChageBackDate((prev) => new Date(prev.getTime() + 1));
                    } else {
                      setTempChageBackDate(value);
                      const dateRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-\d{4}$/;
                      const formattedDate = value ? DateFormater(value) : "";

                      if (!dateRegex.test(formattedDate)) {
                        return
                      };
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);

                      const selectedDate = new Date(value);
                      selectedDate.setHours(0, 0, 0, 0);

                      if (selectedDate > today) {
                        return;
                      }
                      setDate(value);
                    }
                  }}
                  cleanable={false}
                  format="MM/dd/yyyy"
                  oneTap
                  size="md"
                  className="no-clear"
                  caretAs={() => <ArrowDownIcon style={{ fontSize: 20 }} />}
                  ranges={[
                    {
                      label: "Today",
                      value: today,
                    },
                    {
                      label: "Clear",
                      value: null,
                    },
                  ]}
                />
              </div>
            </Stack>

            {selectedTab === "Pending" && (
              <>

                <CustomSelect
                  label="Status"
                  options={statusList}
                  selectedValue={status?.statusValue}
                  onChange={setStatus}
                  getValue={(s) => s.statusValue}
                  getLabel={(s) => s.statusName}
                />
              </>
            )}
          </Stack>

          {showCard && selectedTab === "Reversed" && Number(last30Days) !== 0 && (
            <SuccessCard
              message="successful chargeback reversals in the past 30 days."
              onClose={() => setShowCard(false)}
            />
          )}

          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-end"}
          >
            <ToggleButtonGroup
              value={selectedTab}
              exclusive
              onChange={(e, newTab) => {
                if (newTab) {
                  setSelectedTab(newTab);
                  if (newTab === "Reversed") {
                    setShowCard(true);
                  }
                }
              }}
            >
              {tabInfo.map((tab) => (
                <ToggleButton
                  key={tab.tabName}
                  value={tab.tabName}
                  sx={{
                    p: "0.5px",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    px: 6,
                    fontSize: 12,

                    "&.Mui-selected": {
                      backgroundColor: "#e7e7e7",
                      color: "black",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#e7e7e7",
                    },
                  }}
                >
                  <Stack direction={"column"} gap={0}>
                    {tab.tabName}
                    {/* <span style={{ fontSize: 10, padding: 0 }}>${tab.amount}</span> */}
                    <span style={{ fontSize: 10, padding: 0 }}>
                      {" "}
                      ${formatAmount(tabAmounts[tab.key])}
                    </span>
                  </Stack>
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </Stack>

        <Box height={"calc(100% - 110px)"} border={"1px solid #d8d8d8"}>
          {selectedTab === "Pending" ? (
            <PendingTable
              initialRows={selectedTabData}
              onUpdateTabValues={ChargeBackTabValues}
              selectedCorpState={selectedCorpState.ID}
              setLoading={setLoading}
            />
          ) : (
            <ChargeBacksTabTable rows={selectedTabData} tab={selectedTab} />
          )}
        </Box>
      </Stack>
      {loading && <Loader loading={loading} />}
    </>
  );
};

export default Chargebacks;
